import { cn } from '@/lib/cn'
import { formatMoney } from '@/lib/formatters'
import { type DisplayCurrency, useUIStore } from '@/stores/ui.store'

interface Props {
  centimes: number
  className?: string
  size?: 'sm' | 'md' | 'lg'
  currency?: DisplayCurrency
}

const sizes = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-lg font-semibold',
}

export function CurrencyAmount({ centimes, className, size = 'md', currency }: Props) {
  const defaultCurrency = useUIStore((s) => s.defaultCurrency)
  const usdRate = useUIStore((s) => s.usdRate)
  const eurRate = useUIStore((s) => s.eurRate)
  const c = currency ?? defaultCurrency
  return (
    <span className={cn(sizes[size], className)}>
      {formatMoney(centimes, c, usdRate, eurRate)}
    </span>
  )
}
